/**
 *
 * Asynchronously loads the component for OktaAuthHandler
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
